import { proxy } from 'valtio';

interface TrustedDocumentState {
  stepsTrusted: boolean;
  stepsCleaned: boolean;
  snapshotTrusted: boolean;
}

/**
 * State used to track whether we think the board is dirty or not based on what we receive back
 * from fetching the snapshot/steps
 */
export const currentDocumentTrustedState: TrustedDocumentState = proxy({
  stepsTrusted: false,
  stepsCleaned: false,
  snapshotTrusted: false,
});

export function isDocumentTrusted() {
  if (
    !currentDocumentTrustedState.snapshotTrusted &&
    currentDocumentTrustedState.stepsTrusted &&
    currentDocumentTrustedState.stepsCleaned
  ) {
    return true;
  }

  return (
    currentDocumentTrustedState.snapshotTrusted &&
    currentDocumentTrustedState.stepsTrusted
  );
}

export const resetDocumentTrustedState = () => {
  currentDocumentTrustedState.stepsTrusted = false;
  currentDocumentTrustedState.stepsCleaned = false;
  currentDocumentTrustedState.snapshotTrusted = false;
};
